import React, { useEffect } from 'react';
import { api } from '../lib/api';

/**
 * Injects Meta Pixel, Google Analytics/GTM, and TikTok Pixel scripts based on backend config.
 * All pixels are configurable from the admin dashboard.
 */
export default function PixelInjector() {
  useEffect(() => {
    let mounted = true;
    // Guard: /register and /fnb are served as standalone static HTML with their own
    // embedded pixels. Skip the shell injector there to avoid double PageView.
    const path = window.location.pathname;
    if (path.startsWith('/register') || path.startsWith('/fnb')) return;
    api.get('/config/public').then(({ data }) => {
      if (!mounted) return;
      injectMetaPixel(data.meta_pixel_id);
      injectGA(data.ga_measurement_id);
      injectGTM(data.gtm_id);
      injectTikTok(data.tiktok_pixel_id);
    }).catch(() => {});
    return () => { mounted = false; };
  }, []);
  return null;
}

function injectMetaPixel(id) {
  if (!id || window.__meta_pixel_loaded) return;
  window.__meta_pixel_loaded = true;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
    document,'script','https://connect.facebook.net/en_US/fbevents.js');
  window.fbq('init', id);
  window.fbq('track', 'PageView');
  /* eslint-enable */
}

function injectGA(id) {
  if (!id || window.__ga_loaded) return;
  window.__ga_loaded = true;
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag(){ window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', id);
}

function injectGTM(id) {
  if (!id || window.__gtm_loaded) return;
  window.__gtm_loaded = true;
  /* eslint-disable */
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
  var f=d.getElementsByTagName(s)[0], j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';
  j.async=true; j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer', id);
  /* eslint-enable */
}

function injectTikTok(id) {
  if (!id || window.__tt_loaded) return;
  window.__tt_loaded = true;
  /* eslint-disable */
  !function (w, d, t) {
    w.TiktokAnalyticsObject = t; var ttq = w[t] = w[t] || [];
    ttq.methods = ["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"];
    ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }; };
    for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    ttq.instance = function (t) { for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]); return e; };
    ttq.load = function (e, n) {
      var r = "https://analytics.tiktok.com/i18n/pixel/events.js";
      ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = r;
      ttq._t = ttq._t || {}; ttq._t[e] = +new Date; ttq._o = ttq._o || {}; ttq._o[e] = n || {};
      var o = document.createElement("script"); o.type = "text/javascript"; o.async = !0; o.src = r + "?sdkid=" + e + "&lib=" + t;
      var a = document.getElementsByTagName("script")[0]; a.parentNode.insertBefore(o, a);
    };
    ttq.load(id); ttq.page();
  }(window, document, 'ttq');
  /* eslint-enable */
}
